import { Routes } from '@angular/router';
import { routesSysadminDefault } from './routes_sysadmin_default';
import { routesSysadminLocalidades } from './routes_sysadmin_localidades';
import { routesSysadminPrecificacao } from './routes_sysadmin_precificacao';

export const routesSysadmin: Routes = [
  ...routesSysadminDefault,
  ...routesSysadminLocalidades,
  ...routesSysadminPrecificacao
];
